import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhoneAlt, FaHeadset } from 'react-icons/fa';

const ContactSection = styled.section`
  padding: 0;
`;

const Title = styled(motion.h2)`
  text-align: center;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  margin-bottom: 12px;
  color: #1a1a1e;
`;

const Subtitle = styled(motion.p)`
  text-align: center;
  font-size: 1.05rem;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 32px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

const CardsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContactCard = styled(motion.a)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  padding: 28px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  color: inherit;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.12);
  }
`;

const IconWrap = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.$tone === 'mail'
    ? 'rgba(37, 99, 235, 0.1)'
    : 'rgba(22, 163, 74, 0.1)'};
  color: ${props => (props.$tone === 'mail' ? '#1d4ed8' : '#15803d')};
  font-size: 1.25rem;
`;

const CardLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
`;

const CardValue = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a1a1e;
  line-height: 1.4;
`;

const CardHint = styled.span`
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.5;
`;

const InfoBox = styled(motion.div)`
  margin-top: 28px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  padding: 22px 24px;
  border-radius: 16px;
  background: rgba(58, 58, 66, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: flex-start;
  gap: 14px;
  color: rgba(0, 0, 0, 0.62);
  line-height: 1.6;

  svg {
    margin-top: 3px;
    color: #3a3a42;
    flex-shrink: 0;
  }
`;

export const ContactUs = () => {
  return (
    <ContactSection>
      <Title
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Bize Ulaşın
      </Title>
      <Subtitle
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        Demo, fiyatlandırma veya teknik destek için ekibimizle doğrudan iletişime geçin.
      </Subtitle>

      <CardsGrid
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.16 }}
      >
        <ContactCard
          href="mailto:info@altinyazilim.com"
          whileTap={{ scale: 0.98 }}
        >
          <IconWrap $tone="mail">
            <FaEnvelope />
          </IconWrap>
          <CardLabel>E-posta</CardLabel>
          <CardValue>info@altinyazilim.com</CardValue>
          <CardHint>Detaylı bilgi ve teklif talepleri için yazın.</CardHint>
        </ContactCard>

        <ContactCard
          href="tel:+902164497049"
          whileTap={{ scale: 0.98 }}
        >
          <IconWrap $tone="phone">
            <FaPhoneAlt />
          </IconWrap>
          <CardLabel>Telefon</CardLabel>
          <CardValue>+90 216 449 70 49</CardValue>
          <CardHint>Hafta içi mesai saatlerinde hızlı destek.</CardHint>
        </ContactCard>
      </CardsGrid>

      <InfoBox
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.24 }}
      >
        <FaHeadset size={18} />
        <span>
          Altın Mobile hakkında sorularınız için bize ulaşın. Ekibimiz kurulum,
          lisanslama ve modül seçimi konularında size yardımcı olur.
        </span>
      </InfoBox>
    </ContactSection>
  );
};
